import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledHeading5 = makeDefaultTypographyStyled(
  'Heading5',
  'h5',
  1.2,
  1.2,
);
